<div class="card">
  <!-- KT doc §8.4: confirm this binds to PatchingCompliance or metSLA% before wiring real data -->
  <h3 class="card__title">Overall Patch Compliance</h3>
  <div class="gauge">
    <div class="gauge-crop">
      <canvas
        baseChart
        [type]="'doughnut'"
        [data]="gaugeChartData"
        [options]="gaugeChartOptions"
        [plugins]="gaugeChartPlugins"
      ></canvas>
    </div>
  </div>
</div>
